module.exports = __webpack_public_path__ + "dbf1b0f7285fe88878e8fc5d3336b80e.png";